import { SalesDocument } from "@icc/b2b/shared";

export abstract class DocumentPricesService {
    constructor() {}

    abstract recalculatePosition(
        salesDocument: SalesDocument,
        specifiedPositions?: string[],
        showToasts?: boolean,
        buy?: boolean,
        force?: boolean,
    ): Promise<boolean>;
}
